<script type="text/ecmascript-6">
import CreateMediaDownloadPackage from '../../../../Packages/resources/js/components/CreateMediaDownloadPackage'
import AddMediaToCampaign from '../AddMediaToCampaign.vue'

export default {
    components: {
        CreateMediaDownloadPackage,
        AddMediaToCampaign
    },

    data: function () {
        return {
            baseUrl: Scoop.baseUrl,
            downloadPackageStep: null,
            mediaVisible: false,
            selectedInPr: null,
            windowOpenAddToPr: false,
            windowOpenAddToCampaign: false,
        }
    },

    computed: {
        mediaSelected: {
            get: function () {
                return scoopOS.getSelected('medias');
            },
            set: function (newValue) {
                scoopOS.replaceAll('medias', newValue);
            }
        },
        mediaTools() {
            return scoopOS.tools ? scoopOS.tools.medias : null;
        },
        count() {
            return this.mediaSelected.length;
        },
        mediaUrls() {
            let selectedMediaIds = scoopOS.getSelected('medias');

            return _.mapValues(_.zipObject(selectedMediaIds, selectedMediaIds), (id) => {
                return Scoop.baseUrl + '/mediaserver/media/' + id + '?format=SCOOP_OS_SMALL';
            });
        }
    },

    methods: {
        deselect() {
            scoopOS.deselectAll('medias');
        },
        countApplicableModels(className) {
            if (!this.mediaTools || !this.mediaTools[className]) {
                return -1;
            }
            return this.mediaTools[className].length;
        },
        allowedToSee(className) {
            return this.countApplicableModels(className) > 0;
        },
        showMedia() {
            this.mediaVisible = true;
            this.$refs['showMediaModal'].click();
        },
        showDeleteMediaModal() {
            this.$refs['deleteMediaModal'].click();
        },
        deleteMedia() {
            axios.delete(Scoop.baseUrl + '/mediaserver/media/' + this.mediaSelected).then(response => {
                if (response.data.success) {
                    window.location.reload();
                } else {
                    toastr.error('Deleting media failed!');
                    console.log(response);
                }
            });
        },
        tooglePrStatus(mediaId) {
            let isSelectedInPr = this.selectedInPr.indexOf(parseInt(mediaId)) !== -1;

            if (!isSelectedInPr) {
                axios.post(Scoop.baseUrl + '/pr/selectMedia', {'mediaId': mediaId})
                    .then(response => {
                        this.selectedInPr = response.data;
                    });
            } else {
                axios.delete(Scoop.baseUrl + '/pr/selectMedia/' + mediaId)
                    .then(response => {
                        this.selectedInPr = response.data;
                    });
            }
        }
    }
}
</script>
<template>


    <li id="selected-media-widget" v-if="count > 0" class="dropdown">
        <portal to="modals">
            <Lightbox
                    id="showSelectedMedia"
                    headline="Selected media"
                    large="true"
            >
                <span slot="open-template" ref="showMediaModal"></span>
                <div slot="body" class="row">
                    <div class="col-md-3 m-b m-t" v-for="(mediaUrl, id) in mediaUrls" v-if="mediaVisible">
                        <a :href="baseUrl+'/mediaserver/media/'+id+'/edit'">
                            <img :src="mediaUrl" class="img-thumbnail"/>
                        </a>
                    </div>
                </div>
            </Lightbox>
            <Lightbox
                    id="deleteSelectedMedia"
                    :headline="__('Delete '+this.mediaSelected.length+' media')"
            >
                <span slot="open-template" ref="deleteMediaModal"></span>
                <div slot="body" class="row">
                    <div class="text-center">
                        <p>{{ __('scoop-os.media.delete_image_text') }}</p>
                        <a class="btn btn-primary btn-sm" href="#" @click="deleteMedia">{{
                                __('scoop-os.media.delete_image_btn')
                            }}</a>
                        <button type="button" class="btn btn-white" data-dismiss="modal">{{
                                __('scoop-os.media.delete_image_close_btn')
                            }}
                        </button>
                    </div>
                </div>
                <div v-cloak slot="footer"></div>
            </Lightbox>
            <template v-if="allowedToSee('ScoopModelSelectorToolsAddToPr')">
                <add-media-to-pressdatabase
                        :window-open-add-to-pr="windowOpenAddToPr"
                        @close="windowOpenAddToPr = false"
                />
            </template>

            <template v-if="allowedToSee('ScoopModelSelectorToolsAddToCampaign')">
                <add-media-to-campaign
                        :open-modal="windowOpenAddToCampaign"
                        @close="windowOpenAddToCampaign = false"
                />
            </template>
        </portal>

        <a class="dropdown-toggle count-info"
           data-toggle="dropdown"
           href="#"
           aria-expanded="true"
        >
            <i class="fa fa-picture-o"></i>
            <template v-if="!mediaTools">
                <div class="label label-primary spin-icon">
                    <i class="fa fa-gear fa-spin"></i>
                </div>
            </template>
            <template v-else>
                <span class="label label-warning" v-text="count"></span>
            </template>
        </a>
        <ul class="dropdown-menu dropdown-alerts">
            <li v-show="allowedToSee('ScoopModelSelectorToolsAddToPackage')">
                <a :href="baseUrl+'/mediaserver/packages'">
                    <div>
                        <i class="fa fa-folder-open-o fa-fw"></i>
                        <span v-text="__('Add to package')"></span>
                    </div>
                </a>
                <div class="divider"></div>
            </li>
            <li v-show="allowedToSee('ScoopModelSelectorToolsAddToPr')">
                <a @click="windowOpenAddToPr = true">
                    <div>
                        <i class="fa fa-folder-open-o fa-fw"></i>
                        <span v-text="__('Add to PR Database')"></span>
                    </div>
                </a>
                <div class="divider"></div>
            </li>
            <li v-show="allowedToSee('ScoopModelSelectorToolsAddToCampaign')">
                <a @click="windowOpenAddToCampaign = true">
                    <div>
                        <i class="fa fa-folder-open-o fa-fw"></i>
                        <span v-text="__('Add to Campaign')"></span>
                    </div>
                </a>
                <div class="divider"></div>
            </li>
            <li v-show="allowedToSee('ScoopModelSelectorToolsDeleteMedia')">
                <a @click="showDeleteMediaModal">
                    <div>
                        <i class="fa fa-trash fa-fw text-danger"></i>
                        <span v-text="__('Delete '+this.mediaSelected.length+' media')"></span>
                    </div>
                </a>
                <div class="divider"></div>
            </li>
            <li v-show="allowedToSee('ScoopModelSelectorToolsShowMedia')">
                <a @click="showMedia">
                    <div>
                        <i class="fa fa-picture-o fa-fw"></i>
                        <span v-text="__('Show '+countApplicableModels('ScoopModelSelectorToolsShowMedia')+' media')"></span>
                    </div>
                </a>
                <div class="divider"></div>
            </li>
            <li>
                <a @click="deselect">
                    <div>
                        <i class="fa fa-eraser fa-fw"></i>
                        <span v-text="__('Deselect '+this.mediaSelected.length+' media')"></span>
                    </div>
                </a>
            </li>
        </ul>
    </li>
</template>
